import { render, staticRenderFns } from "./VisitorReservationDetail.vue?vue&type=template&id=7b920d63&scoped=true&"
import script from "./VisitorReservationDetail.vue?vue&type=script&lang=js&"
export * from "./VisitorReservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./VisitorReservationDetail.vue?vue&type=style&index=0&id=7b920d63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b920d63",
  null
  
)

export default component.exports